module.exports = __webpack_public_path__ + "img/dgroup_16.a11630bf.jpg";